
























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { UiImage } from '../../ui-image';
import { UiObserveVisibility } from '../../ui-observe-visibility';
import { UiStatistic } from '../../ui-statistic';

import type { NewsLImage, NewsLStatistic } from './ui-news-l.contract';

@Component({
  components: {
    UiStatistic,
    UiObserveVisibility,
    UiImage
  },
  name: 'UiNewsL'
})
export default class UiNewsL extends Vue {
  @Prop({
    type: String,
    required: true
  })
  title!: string;

  @Prop({
    type: String,
    required: true
  })
  url!: string;

  @Prop({
    type: Object as () => NewsLImage,
    required: true
  })
  image!: NewsLImage;

  @Prop({
    type: Object as () => NewsLStatistic,
    required: true
  })
  statistic!: NewsLStatistic;

  @Prop({
    type: Boolean,
    default: false
  })
  isBookmarked: boolean;

  @Emit('blockShown')
  blockShown(): void {
    return;
  }

  @Emit('commentClicked')
  commentClicked(event: Event): Event {
    return event;
  }

  @Emit('bookmarkClicked')
  bookmarkClicked(event: Event): Event {
    return event;
  }

  @Emit('articleClicked')
  articleClicked(place: string): string {
    return place;
  }
}
